
import React, {useEffect, useState} from 'react';
import Button from 'components/Button';
import {Routes} from 'constants/index';
import {Link} from 'gatsby';
import {cookies, CookKey} from 'utils/cookies';

import * as styles from './styles.module.scss';

const CookieBanner = () => {
	const [show, setShow] = useState<boolean>(false);
	const AcceptValue = 'accepted';

	// Load cookie value dynamically; don't show in SSR
	useEffect(() => {
		const accepted = (cookies.get(CookKey.CookieBanner) === AcceptValue);
		if (!accepted) {
			setShow(true);
		}
	}, []);

	if (!show) {
		return null;
	}

	const onClick = () => {
		cookies.set(CookKey.CookieBanner, AcceptValue, {expires: 365});
		setShow(false);
	};

	return (
		<div className={styles.wrapper}>
			<div className={styles.banner}>
				<span>
					This site uses cookies for analytics and functionality.
					{' '}<Link to={Routes.privacyPolicy}>Read more here.</Link>
				</span>
				<Button variant='ol-green' onClick={onClick}>
					OK
				</Button>
			</div>
		</div>
	);
};

export default CookieBanner;
